import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Function to check if the entire element is outside the viewport
function isElementFullyOutsideViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.bottom < 0 || // Element is above the viewport
        rect.top > (window.innerHeight || document.documentElement.clientHeight) // Element is below the viewport
    );
}

// Check if there are elements with the 'fade-in-element' class
if (document.querySelector(".fade-in-element")) {
    // Select all elements with the 'fade-in-element' class
    const fadeInElements = gsap.utils.toArray(".fade-in-element");

    // Iterate over each element with the 'fade-in-element' class
    fadeInElements.forEach((element) => {
        // Only apply animation if the entire element is OUTSIDE the viewport
        if (isElementFullyOutsideViewport(element)) {
            gsap.from(element, {
                scrollTrigger: {
                    trigger: element,
                    start: "top 90%", // Start animation when element is 90% in view
                    toggleActions: "play none none none", // Plays only once
                },
                opacity: 0, // Fade in from opacity 0
                duration: 1.5, // Animation duration
                ease: "power1.out", // Easing function
            });
        }
    });
}